<template>
  <v-toolbar>
    <v-toolbar-title v-if="campaign.title">
      {{ t("campaign.type." + campaign.type) }}:
      {{ campaign.title[user.locale] }}
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn variant="text" :href="campaign.preview_link" target="_blank">
      <v-icon start>mdi-open-in-new</v-icon>{{ t("generic.btn_preview") }}
    </v-btn>
  </v-toolbar>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '@/stores/auth'
import { useCampaignStore } from '@/stores/campaign'

const { t } = useI18n()
const authStore = useAuthStore()
const campaignStore = useCampaignStore()

const campaign = computed(() => campaignStore.campaign)
const user = computed(() => authStore.user)
</script>
